import { FC } from 'react';
import intl from 'react-intl-universal';
import { Toggle } from '@getsynapse/design-system';

interface EnableAccountToggleSwitchProps {
  isAccountEnabled: boolean;
  handleEnableDisable: () => Promise<void>;
  toggleDisabled: boolean;
}

const EnableAccountToggleSwitch: FC<EnableAccountToggleSwitchProps> = ({
  isAccountEnabled,
  handleEnableDisable,
  toggleDisabled,
}) => {
  return (
    <Toggle
      label={intl.get('SETTINGS_PAGE.USER_PAGE.HEADER.ENABLE_ACCOUNT')}
      labelProps={{ className: 'mb-0 mr-2' }}
      className='flex items-center'
      isSmall
      id='enable-account-toggle'
      checked={isAccountEnabled}
      onChange={handleEnableDisable}
      disabled={toggleDisabled}
    />
  );
};

export default EnableAccountToggleSwitch;
